import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { QuotesFacade } from '@common/data-access-quotes';
import { CmsDataService, cmsDataUrl } from '@common/data-access-shared';
import { CmsData, CmsPage } from '@common/util-models';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class QuoteCmsPageResolver implements Resolve<Observable<CmsData>> {
  constructor(
    private cmsDataService: CmsDataService,
    private quotesFacade: QuotesFacade
  ) {}

  resolve(): Observable<CmsData> {
    const baseUrl = cmsDataUrl[CmsPage.Quote]?.url;
    return this.quotesFacade.isHeating$.pipe(
      map((isHeating) => {
        return `${baseUrl}/${
          isHeating ? 'heating-policy-features' : 'policy-features-1'
        }`;
      }),
      first(),
      switchMap((quoteCmsPageUrl) =>
        this.cmsDataService.getCmsData({
          id: CmsPage.Quote,
          url: quoteCmsPageUrl,
        })
      )
    );
  }
}
